import '@/assets/styles/global.scss';
import { message } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import isBetween from 'dayjs/plugin/isBetween';
import '../tailwind.css';
import { openUpdateVersionNotify } from './tools/fetchUpdateVersionFile';

dayjs.locale('zh-cn');
dayjs.extend(isBetween);
message.config({
  maxCount: 1,
});
const { NODE_ENV } = process.env;
console.log(NODE_ENV);
if (NODE_ENV !== 'development') {
  openUpdateVersionNotify();
}
